import * as React from 'react'

import { StoreTypes } from 'src/stores/types'
import { StoresContext } from 'src/components/Wrapper/Wrapper'

export default () => React.useContext<StoreTypes>(StoresContext)
